module.exports = __webpack_public_path__ + "img/stock4.03bba908.png";